import { Navigate, Route, Routes } from "react-router-dom";
import React, { useEffect } from "react";
import { webV1Url } from "@bluecrew/web-react-core/src/constants";
import { TIMETRACKING_LEGACY_VIEW_SPLIT_NAME } from "../../shared/constants";
import { getTreatmentValue } from "../redux/selectors/splitio";
import { Timesheets } from "../containers/Payroll/Timesheets";
import { PayrollReports } from "../containers/Payroll/PayrollReports";
import { getUserCompany, getUserType } from "../redux/selectors/auth";
import { TimesheetSupportUserTypes } from "../containers/Payroll/types/Payroll.types";
import { useAppSelector } from "../redux";

export const PayrollRoutes = () => {
  const showTimesheetsInAngular = useAppSelector((state) =>
    getTreatmentValue(state, TIMETRACKING_LEGACY_VIEW_SPLIT_NAME),
  );
  const userType = useAppSelector(getUserType);
  const companyId = useAppSelector(getUserCompany);

  useEffect(() => {
    if (showTimesheetsInAngular === "on") {
      window.location.href = `${webV1Url}/app.html#!/payroll/company`;
    }
  }, [showTimesheetsInAngular]);

  return (
    <Routes>
      <Route
        path="/"
        element={
          TimesheetSupportUserTypes.includes(userType) ? (
            <PayrollReports />
          ) : (
            <Navigate to={`../${companyId}`} />
          )
        }
      />
      <Route path="/:internalCompanyId" element={<Timesheets />} />
    </Routes>
  );
};
